jQuery(document).ready(function($){
// init Masonry
//Check to see if page has class .grid before executing js
if ($('.grid')[0]){

var $grid = $('.grid').masonry({
  // options...
      // use outer width of grid-sizer for columnWidth
      columnWidth: '.grid-sizer',
      gutter: '.gutter-sizer',
      itemSelector: '.grid-item',
      // percentPosition: true
});
$grid.imagesLoaded().progress( function() {
  $grid.masonry('layout');
});
}
});



jQuery(document).ready(function($) {
    $('.gallery').magnificPopup({
        delegate: 'a', // child items selector, by clicking on it popup will open
        type: 'image',
        gallery: {
            enabled: true
          },
          image: {
            titleSrc: 'data-caption' 
            // this tells the script which attribute has your caption
        },
          mainClass: 'mfp-with-zoom', // this class is for CSS animation below
          fixedContentPos: true,
  zoom: {
    enabled: true, // By default it's false, so don't forget to enable it
  
    duration: 300, // duration of the effect, in milliseconds
    easing: 'ease-in-out', // CSS transition easing function
  
    // The "opener" function should return the element from which popup will be zoomed in
    // and to which popup will be scaled down
    // By defailt it looks for an image tag:
    opener: function(openerElement) {
      // openerElement is the element on which popup was initialized, in this case its <a> tag
      // you don't need to add "opener" option if this code matches your needs, it's defailt one.
      return openerElement.is('img') ? openerElement : openerElement.find('img');
    }
  },
  // sort of fixes croll issue on ios devices
  callbacks: {
    beforeOpen: function () {
    this.st.mainClass = this.st.el.attr('data-effect');
    }, open: function () {
    $('html').css('overflow', 'hidden').css('margin-right', '0');
    },close:function (){
    $('html').css('overflow', 'auto').css('margin-right', '0');
    }
    },
    
    
  
        // other options
    }); 
  
   
  
  });

  // Slide open Menu
(function($) {
  // $(".item-nav").click(function(){
  //   $(".tab").toggleClass("show");
  // });
  
    $(".menu-icon").click(function(){
      // $(".item-glance").toggleClass("active");
      $("#header-nav").slideToggle("slow");
    });
  
  })( jQuery );


  // Vertical Tiomeline
  (function () {
    "use strict";
  
    // define variables
    var items = document.querySelectorAll(".timeline li");
  
    // check if an element is in viewport
    // http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
    function isElementInViewport(el) {
      var rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }
  
    function callbackFunc() {
      for (var i = 0; i < items.length; i++) {
        if (isElementInViewport(items[i])) {
          items[i].classList.add("in-view");
        }
      }
    }
  
    // listen for events
    window.addEventListener("load", callbackFunc);
    window.addEventListener("resize", callbackFunc);
    window.addEventListener("scroll", callbackFunc);
  })();
  